import React, {Component} from 'react';
import Request from '../request';
import Validation from '../Validation';
import {URL, TOKEN} from "../constants";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './contact.css';
import ReCAPTCHA from "react-google-recaptcha";

class Contact extends Component {
    state = {
        lang: this.props.lang,
        pageData: {},
        name: "",
        email: "",
        title: "",
        content: "",
        captcha: "",
        placeholders: {
            name: (this.props.lang === "tr") ? "Adı Soyadı" : "Name",
            email: (this.props.lang === "tr") ? "E-Posta Adresi" : "E-Mail",
            title: (this.props.lang === "tr") ? "Konu" : "Subject",
            content: (this.props.lang === "tr") ? "Mesaj" : "Inquiry"
        }
    };

    componentWillMount() {
        fetch(URL + "social", {
            headers: {"Authorization": "Bearer " + TOKEN}
        })
            .then(response => response.json())
            .then(response => {
                if (response.status === "error") {
                    console.log(response.data);
                    return false;
                }
                this.setState({pageData: response.data});
            })
            .catch(reason => console.log(reason));
    }

    componentWillReceiveProps(props) {
        if (props.lang === this.state.lang) return false;
        this.setState({
            lang: props.lang,
            placeholders: {
                name: (props.lang === "tr") ? "Adı Soyadı" : "Name",
                email: (props.lang === "tr") ? "E-Posta Adresi" : "E-Mail",
                title: (props.lang === "tr") ? "Konu" : "Subject",
                content: (props.lang === "tr") ? "Mesaj" : "Inquiry"
            }
        });
    }


    submitHandler(e) {
        e.preventDefault();

        if(this.state.captcha.length < 1){
            let message = "Lütfen Doğrulama İşlemini Tamamlayınız.";
            if (this.state.lang === "eng") {
                message = "Conformation should be complete.";
            }
            toast.error(message, {position: toast.POSITION.TOP_CENTER});
            return false;
        }


        const {name, email, title, content} = this.state;
        const errors = {};
        const update = {};
        update.placeholders = {};

        errors.name = Validation("empty", name,undefined, this.props.lang);
        if (errors.name.length > 0) {
            update.name = "";
            update.placeholders.name = errors.name;
            //toast.error("İsim: " + errors.name, {position: toast.POSITION.TOP_CENTER});
        }

        errors.email = Validation("email", email,undefined, this.props.lang);
        if (errors.email.length > 0) {
            update.email = "";
            update.placeholders.email = errors.email;
            //toast.error("E-Posta: " + errors.email, {position: toast.POSITION.TOP_CENTER});
        }

        errors.title = Validation("empty", title,undefined, this.props.lang);
        if (errors.title.length > 0) {
            update.title = "";
            update.placeholders.title = errors.title;
            //toast.error("Başlık: " + errors.title, {position: toast.POSITION.TOP_CENTER});
        }

        errors.content = Validation("empty", content, undefined,this.props.lang);
        if (errors.content.length > 0) {
            update.content = "";
            update.placeholders.content = errors.content;
            //toast.error("Mesaj: " + errors.content, {position: toast.POSITION.TOP_CENTER});
        }

        this.setState(update);

        let result = true;
        Object.values(errors).map(val => {
            if (val.length > 0) {
                result = false;
            }
            return true;
        });
        if (result === true) {
            Request.post("contact", {name, email, title, content})
                .then(response => {
                    if (response.status === "error") {
                        console.log(response.data);
                        return false;
                    }
                    let message = "Mesajınız başarıyla gönderilmiştir.";
                    if (this.state.lang === "eng") {
                        message = "Your message has been sent successfully.";
                    }
                    toast.success(message, {position: toast.POSITION.TOP_CENTER});
                    this.setState({name: "", email: "", title: "", content: ""});
                })
                .catch(e => console.log(e));
        }
        return false;
    }

    render() {
        const mailto = "mailto:" + this.state.pageData.email;
        return <div className="contact">
            <div className="contactContainer">
                <div className="contactMap">
                    <iframe
                        title="companyLocation"
                        src={this.state.pageData.map}
                        width="100%" height="100%" frameBorder="0" allowFullScreen/>
                </div>
                <div className="contactFormContainer">
                    <form onSubmit={this.submitHandler.bind(this)}>
                        <h2>{this.props.lang === "tr" && "İLETİŞİM" }
                            {this.props.lang === "eng" && "CONTACT" }
                        </h2>
                        <div className="contactFormInfo">
                            <div className="contactFormElement">
                                <input
                                    value={this.state.name}
                                    onChange={(e) => this.setState({name: e.target.value})} type="text" id="name"
                                    placeholder={this.state.placeholders.name}/>
                            </div>
                            <div className="contactFormElement">
                                <input
                                    value={this.state.email}
                                    onChange={(e) => this.setState({email: e.target.value})} type="text" id="email"
                                    placeholder={this.state.placeholders.email}/>
                            </div>
                        </div>
                        <div className="contactFormElement">
                            <input onChange={(e) => this.setState({title: e.target.value})} type="text" id="title"
                                   value={this.state.title}
                                   placeholder={this.state.placeholders.title}/>
                        </div>
                        <div className="contactFormElement">
                            <textarea onChange={(e) => this.setState({content: e.target.value})} rows={5} id="content"
                                      value={this.state.content}
                                      placeholder={this.state.placeholders.content}></textarea>
                        </div>
                        <div className="contactFormElement">
                            <ReCAPTCHA
                                sitekey="6Lejgq0UAAAAAMs1e0uYXLY7j0UxeycskVrRKCbu"
                                onChange={(e)=>this.setState({captcha: e})}
                            />
                        </div>
                        <div className="contactFormElement">
                            {this.props.lang === "tr" && <input type="submit" value="GÖNDER"/>}
                            {this.props.lang === "eng" && <input type="submit" value="SEND"/>}
                        </div>
                    </form>
                </div>
            </div>
            <div className="contactInfo">
                <div className="contactAddress">
                    <i className="fa fa-map-marker"></i>
                    {this.props.lang === "tr" && <h2>ADRES</h2>}
                    {this.props.lang === "eng" && <h2>ADDRESS</h2>}
                    {this.props.lang === "tr" && this.state.pageData.address_tr}
                    {this.props.lang === "eng" && this.state.pageData.address_eng}
                </div>
                <div className="contactPhone">
                    <i className="fa fa-phone"></i>
                    {this.props.lang === "tr" && <h2>TELEFON</h2>}
                    {this.props.lang === "eng" && <h2>PHONE</h2>}
                    {this.props.lang === "tr" && "Tel:"}
                    {this.props.lang === "eng" && "Phone:"}
                    {this.state.pageData.phone}<br/>
                    {this.props.lang === "tr" && "Fax:"}
                    {this.props.lang === "eng" && <label>Fax: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>}
                    {this.state.pageData.fax}
                </div>
                <div className="contactSocial">
                    <i className="fa fa-share-alt"></i>
                    {this.props.lang === "tr" && <h2>BİZİ TAKİP EDİN</h2>}
                    {this.props.lang === "eng" && <h2>FOLLOW</h2>}
                    <a href={mailto}>
                        <i className="fa fa-envelope"></i></a>
                    {   this.state.pageData.instagram !== "" &&
                        <a target="_blank" href={this.state.pageData.instagram}>
                            <i className="fa fa-instagram"></i>
                        </a>
                    }
                    {  this.state.pageData.twitter !== "" &&
                        <a target="_blank" href={this.state.pageData.twitter}>
                            <i className="fa fa-twitter"></i>
                        </a>
                    }
                    {  this.state.pageData.youtube !== "" &&
                    <a target="_blank" href={this.state.pageData.youtube}>
                        <i className="fa fa-youtube"></i>
                    </a>
                    }
                    {  this.state.pageData.facebook !== "" &&
                    <a target="_blank" href={this.state.pageData.facebook}>
                        <i className="fa fa-facebook"></i>
                    </a>
                    }
                </div>
            </div>
            {this.props.lang === "tr" &&
            <div className="copyright">© 2019 FNS Deniz Sistemleri Tüm Hakları Saklıdır.</div>}
            {this.props.lang === "eng" && <div className="copyright">© 2019 FNS All rights reserved.</div>}
            <ToastContainer/>
        </div>;
    }
}

/*

 */
export default Contact;